export default __webpack_public_path__ + "static/media/preschool-logo.9038496f.png";